import { Button, Collapse } from 'antd';
import React, { useRef } from 'react';
import Editor from '@monaco-editor/react';
import config from '../../../constants/config.json';
import { CaretRightOutlined } from '@ant-design/icons';

const customPanel = {
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
};

const ConfigEditor = (props) => {
  const editorRef = useRef(null);
  const monacoRef = useRef(null);

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    monacoRef.current = monaco;
  };

  const saveConfig = () => {
    if (editorRef.current) {
      const model = editorRef.current.getModel();
      const value = model.getValue();
      try {
        const parsedValue = JSON.parse(value);
        if (typeof parsedValue !== 'string') {
          props.columnEditorObject(parsedValue);
        }
      } catch (e) {
        alert('Error: JSON Parse Failed');
      }
    }
  };

  const items = [
    {
      key: '1',
      label: 'JSON',
      style: customPanel,
      children: (
        <div>
          <Editor
            width="1000px"
            height="40vh"
            theme="vs-dark"
            defaultLanguage="json"
            defaultValue={JSON.stringify(props.form, null, '\t')}
            value={JSON.stringify(props.form, null, '\t')}
            onMount={handleEditorDidMount}
          />
          {config.production !== true && (
            <Button type="primary" onClick={saveConfig} style={{ marginTop: '5px' }}>
              Save
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div style={{ marginTop: '15px' }}>
      <Collapse
        bordered={false}
        style={{ marginTop: '20px' }}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        items={items}
      />
    </div>
  );
};

export default ConfigEditor;
